import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppRooute } from 'src/app/core/common/app-route.model';
import { AppSettings } from 'src/app/core/common/app-settings';
import { RouteConstant } from 'src/app/core/common/route-constant';
import { StateConstant } from 'src/app/core/common/state-constant';
import { TypeOperationEnum } from 'src/app/core/enums/type-operation.enum';
import { DesaparecidoGamService } from 'src/app/core/services/gam/desaparecido-gam.service';
import { DesaparecidoGamDto } from 'src/app/shared/models/gam/desaparecido-gam-dto.model';
import { environment } from 'src/environments/environment';
import { DesaparecidoImageFormComponent } from '../desaparecido-image-form/desaparecido-image-form.component';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { PublicacionService } from 'src/app/core/services/caso/publicacion.service';

@Component({
  selector: 'vex-desaparecido-gam-form',
  templateUrl: './desaparecido-gam-form.component.html',
  styleUrls: ['./desaparecido-gam-form.component.scss']
})
export class DesaparecidoGamFormComponent implements OnInit {
  appSettings = AppSettings;
  stateConstant = StateConstant;
  crumbs: AppRooute[] = [RouteConstant.ROUTE_GAM_DESAPARECIDOS];

  form: FormGroup;
  id: number;
  actionType: string;
  urlThumbnail: string;

  desaparecidoGamService = inject(DesaparecidoGamService);
  publicacionService = inject(PublicacionService);

  dto: DesaparecidoGamDto = new DesaparecidoGamDto();
  formLabel: string = "Registro Nuevo";

  nacionalidades: string[] = ['BOLIVIANO', 'EXTRANJERO'];
  generos: string[] = ['MASCULINO', 'FEMENINO'];
  departamentos: string[] = ['La Paz', 'Santa Cruz', 'Cochabamba', 'Oruro', 'Chuquisaca', 'Pando', 'Beni', 'Potosí', 'Tarija'];
  selectedOption = 'BOLIVIANO';

  constructor(private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private dialog: MatDialog,
    private fb: FormBuilder) {

    this.form = this.fb.group({
      documento: [""],
      complemento: [""],
      nacionalidad: ["", Validators.required],
      apellidoMaterno: [""],
      apellidoPaterno: ["", Validators.required],
      nombres: ["", Validators.required],
      fechaNacimiento: ["", Validators.required],
      municipio: ["Nuestra Señora de La Paz", Validators.required],
      sexo: ["", Validators.required],
      departamento: ["", Validators.required],
      fechaDesaparicion: ["", Validators.required],
      horaDesaparicion: [""],
      colorCabellos: [""],
      colorOjos: [""],
      tez: [""],
      peso: [""],
      estatura: [""],
      vestimenta: ["", Validators.required],
      referencia: [""],
      senias: [""],
      lugarHecho: ["", Validators.required],
      resumen: ["", Validators.required],
      encontrado: [false, Validators.required]
    });
  }

  ngOnInit(): void {
    this.actionType = this.route.snapshot.params.actionType;
    if (this.actionType === TypeOperationEnum.UPDATE) {
      this.formLabel = "Datos del desaparecido";
      this.id = this.route.snapshot.params.id;
      this.desaparecidoGamService.findById(this.id)
        .subscribe(
          response => {
            //console.log(response.data)
            this.form.controls['documento'].setValue(response.data.documento);
            this.form.controls['complemento'].setValue(response.data.complemento);
            this.form.controls['nacionalidad'].setValue(response.data.nacionalidad);
            this.form.controls['apellidoMaterno'].setValue(response.data.apellidoMaterno);
            this.form.controls['apellidoPaterno'].setValue(response.data.apellidoPaterno);
            this.form.controls['nombres'].setValue(response.data.nombres);
            this.form.controls['fechaNacimiento'].setValue(response.data.fechaNacimiento);
            //this.form.controls['edadAprox'].setValue(response.data.edadAprox);
            this.form.controls['sexo'].setValue(response.data.sexo);
            this.form.controls['departamento'].setValue(response.data.departamento);
            this.form.controls['fechaDesaparicion'].setValue(response.data.fechaDesaparicion);
            this.form.controls['horaDesaparicion'].setValue(response.data.horaDesaparicion);
            this.form.controls['colorCabellos'].setValue(response.data.colorCabellos);
            this.form.controls['colorOjos'].setValue(response.data.colorOjos);
            this.form.controls['tez'].setValue(response.data.tez);
            this.form.controls['peso'].setValue(response.data.peso);
            this.form.controls['estatura'].setValue(response.data.estatura);
            this.form.controls['referencia'].setValue(response.data.referencia);
            this.form.controls['vestimenta'].setValue(response.data.vestimenta);
            //this.form.controls['senias'].setValue(response.data.senias);
            this.form.controls['lugarHecho'].setValue(response.data.lugarHecho);
            this.form.controls['resumen'].setValue(response.data.resumen);
            this.form.controls['encontrado'].setValue(response.data.encontrado);
            //this.urlThumbnail = `${environment.apiSecurityUrl}api/v1/gam/desaparecidos/${this.id}/photo`;
          },
          err => {
            console.error('Código del error desde el backend: ' + err.status);
            console.error(err.error.errors);
          }
        );
    }
  }

  save() {
    this.dto.documento = this.form.value.documento;
    this.dto.complemento = this.form.value.complemento;
    this.dto.nacionalidad = this.form.value.nacionalidad;
    this.dto.apellidoMaterno = this.form.value.apellidoMaterno;
    this.dto.apellidoPaterno = this.form.value.apellidoPaterno;
    this.dto.nombres = this.form.value.nombres;
    this.dto.fechaNacimiento = this.form.value.fechaNacimiento ? this.form.value.fechaNacimiento : "";
    this.dto.municipio = this.form.value.municipio;
    this.dto.sexo = this.form.value.sexo;
    this.dto.departamento = this.form.value.departamento;
    this.dto.fechaDesaparicion = this.form.value.fechaDesaparicion;
    this.dto.horaDesaparicion = this.form.value.horaDesaparicion;
    this.dto.colorCabellos = this.form.value.colorCabellos;
    this.dto.colorOjos = this.form.value.colorOjos;
    this.dto.tez = this.form.value.tez;
    this.dto.estatura = this.form.value.estatura;
    this.dto.peso = this.form.value.peso;
    this.dto.referencia = this.form.value.referencia;
    this.dto.vestimenta = this.form.value.vestimenta;
    //this.dto.senias = this.form.value.senias;
    this.dto.lugarHecho = this.form.value.lugarHecho;
    this.dto.resumen = this.form.value.resumen;
    this.dto.encontrado = this.form.value.encontrado;
    switch (this.actionType) {
      case TypeOperationEnum.CREATE: {
        this.desaparecidoGamService.persist(this.dto).subscribe(response => {
          if (response.status) {
            this.toastrService.success(response.message);
            this.router.navigate([`./${RouteConstant.ROUTE_GAM_DESAPARECIDOS.url}`]);
          } else
            this.toastrService.warning(response.message);
        });
        break;
      }
      case TypeOperationEnum.UPDATE: {
        this.desaparecidoGamService.update(this.id, this.dto).subscribe(response => {
          if (response.status) {
            this.toastrService.success(response.message);
            this.router.navigate([`./${RouteConstant.ROUTE_GAM_DESAPARECIDOS.url}`]);
          } else
            this.toastrService.warning(response.message);
        });
        break;
      }
    }
  }

  updateFotografia() {
    const dialogRef = this.dialog.open(DesaparecidoImageFormComponent, {
      width: '600px',
      data: {
        title: `Actualizar foto de desaparecido`,
        button: 'Actualizar',
        entity: this.id,
        isComprobante: true
      }
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        window.location.reload()
      }
    });
  }

  foto(): string {
    return environment.apiSecurityUrl + 'api/v1/util/stream/fotos/' + this.id;
  }

  publicar() {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: new ConfirmDialogModel("Cambiar publicado", "¿Está seguro de cambiar el estado de publicado?")
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.publicacionService.cambiarPublicadoByDesaparecido(this.id).subscribe(
          //this.publicacionService.cambiarPublicadoGam(this.id).subscribe(
            response => {
              if (response.status) {
                this.toastrService.success(response.message);
              } else {
                this.toastrService.warning(response.message);
              }
            },
            err => {
              this.toastrService.error(err.data);
            }
          )
        }
      });
  }
}
